<ng-container formGroupName="testSpecification">
    <label class="container">
        <div>
            <div
                style="
                    display: flex;
                    align-items: center;
                    gap: 7px;
                    font-size: 14;
                "
            >
                <div *ngIf="label" [ngStyle]="{'font-weight': labelBold ? 'bold': 'normal'}">
                    {{ label }}
                </div>
                <div *ngIf="code" [ngStyle]="{'font-weight': codeBold ? 'bold': 'normal'}">({{ code }})</div>
            </div>
        </div>
        <input [formControlName]="name" type="checkbox" />
        <span class="checkmark"></span>
    </label>
</ng-container>
